import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchData } from './config'

interface recover {
  code: string
  status: string
}

const initialState: recover = {
  code: '',
  status: ''
}

export const sendEmail = createAsyncThunk<any,string>('sendemail/recover', async (email) => {
  const response = await fetchData().post('/api/guardian/users/forgotpassword', {email})
  const { data } = (await response).data
  return data
})

export const checkLink =  createAsyncThunk<any,string>('checklink/recover', async (code) => {
  const response = await fetchData().get(`/api/guardian/users/forgotpassword/code/${code}`)
  const { data } = (await response).data
  return data
})


interface Propsreset {
  new_password: string
  re_password: string
  code: string
}
export const resetPassword = createAsyncThunk<any, Propsreset>('resetpassword/recover', async({new_password, re_password, code})=>{
  const response = await fetchData().post(`/api/guardian/users/forgotpassword/code/${code}`, { new_password, re_password})
  const { data } = (await response).data
  return data
})

const recoverSlice = createSlice({
  name:'recover',
  initialState,
  reducers:{

  },
  extraReducers:(builder)=>{
    builder.addCase(sendEmail.pending, (state) => {
      state.status = 'sendEmail_loading'
    })
    builder.addCase(sendEmail.fulfilled, (state, { payload }) => {
      state.status = 'sendEmail_success'
    })
    builder.addCase(sendEmail.rejected, (state) => {
      state.status = 'sendEmail_rejected'
    })
    builder.addCase(checkLink.pending, (state) => {
      state.status = 'checkLink_loading'
    })
    builder.addCase(checkLink.fulfilled, (state, { payload }) => {
      state.code =  payload.code
      state.status = 'checkLink_success'
    })
    builder.addCase(checkLink.rejected, (state) => {
      state.status = 'checkLink_rejected'
    })
    builder.addCase(resetPassword.pending, (state) => {
      state.status = 'resetPassword_loading'
    })
    builder.addCase(resetPassword.fulfilled, (state, { payload }) => {
      state.status = 'resetPassword_success'
    })
    builder.addCase(resetPassword.rejected, (state) => {
      state.status = 'resetPassword_rejected'
    })
  }
})

export default recoverSlice.reducer